// extracted by mini-css-extract-plugin
export default {"title":"SectionTitle_title__GnxPb","spaced":"SectionTitle_spaced__NOKdF"};